import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ConsultaProcessoAdministrativo } from './types';

export const INITIAL_STATE: ConsultaProcessoAdministrativo = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultaProcessoAdministrativo {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_PROCESSO_ADMINISTRATIVO_REQUEST: {
				break;
			}
			case Types.CONSULTA_PROCESSO_ADMINISTRATIVO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.CONSULTA_PROCESSO_ADMINISTRATIVO_FAILURE: {
				draft.status = 0;
				draft.data = action.payload;
				break;
			}
			case Types.CONSULTA_PROCESSO_ADMINISTRATIVO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
